module.exports = __webpack_public_path__ + "resources/img/img_edb_1_m_en.2976abe0d678a912c5e9b3b25e886e92.png";